import { render, staticRenderFns } from "./StepItem.vue?vue&type=template&id=b577b0b4&scoped=true"
import script from "./StepItem.vue?vue&type=script&lang=js"
export * from "./StepItem.vue?vue&type=script&lang=js"
import style0 from "./StepItem.vue?vue&type=style&index=0&id=b577b0b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b577b0b4",
  null
  
)

export default component.exports